import { BRAND } from '../shared/theme/paletteDark';
import { ChromePill, type ChromeSize } from './ChromePill';

/**
 * The List layout's header button (contract §16): "Sort by earliest" or "Sort
 * by nearest", then a parchment disc with a downward arrow, as in Sam's Sept 23
 * screenshot. A tap flips to the other order; there is no menu. What happens
 * when Nearest has nowhere to measure from is the page's to decide.
 */

export type SortMode = 'soonest' | 'nearest';

interface Props {
  sort: SortMode;
  size: ChromeSize;
  onFlip: () => void;
  /** Asking for the device's position, on the way to Nearest. */
  busy?: boolean;
}

function DownDisc({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" focusable="false" style={{ display: 'block', flexShrink: 0 }}>
      <circle cx="8" cy="8" r="8" fill={BRAND.parchment} />
      <path
        d="M8 4.4v6.6M5.2 8.4 8 11.2l2.8-2.8"
        fill="none"
        stroke={BRAND.mocha}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SortToggle({ sort, size, onFlip, busy = false }: Props) {
  const word = sort === 'nearest' ? 'nearest' : 'earliest';
  return (
    <ChromePill
      type="button"
      $size={size}
      onClick={onFlip}
      aria-busy={busy || undefined}
      aria-label={`Sorted by ${word}. Sort by ${sort === 'nearest' ? 'earliest' : 'nearest'} instead`}
      // On the narrowest phones the words give way (ellipsis) before the header overflows.
      style={{ paddingRight: size === 'phone' ? 5 : 6, flexShrink: 1 }}
    >
      <span style={{ opacity: busy ? 0.6 : 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>Sort by {word}</span>
      <DownDisc size={size === 'phone' ? 17 : 19} />
    </ChromePill>
  );
}
